import Vue from 'vue'
import Router from 'vue-router'
import store from './store/index'

const routerOptions = [
  { path: '/', name: 'LogIn', componentName: 'LogIn' },
  { path: '/home', name: 'Home', componentName: 'Home', meta: { requiresAuth: true } },

  { path: '/clients', name: 'Clients', componentName: 'Clients', meta: { requiresAuth: true } },
  { path: '/clients/new', name: 'ClientNew', componentName: 'Clients/New', meta: { requiresAuth: true } },
  { path: '/clients/:clientId', name: 'ClientDetail', componentName: 'Clients/Detail', props: true, meta: { requiresAuth: true } },

  { path: '/routes', name: 'Routes', componentName: 'Routes', meta: { requiresAuth: true } },
  { path: '/routes/new', name: 'RouteNew', componentName: 'Routes/New', meta: { requiresAuth: true } },
  { path: '/routes/:routeId', name: 'RouteDetail', componentName: 'Routes/Detail', props: true, meta: { requiresAuth: true } },

  { path: '/products', name: 'Products', componentName: 'Products', meta: { requiresAuth: true } },
  { path: '/products/new', name: 'ProductNew', componentName: 'Products/New', meta: { requiresAuth: true } },
  { path: '/products/:productId', name: 'ProductDetail', componentName: 'Products/Detail', props: true, meta: { requiresAuth: true } },

  { path: '/employees', name: 'Employees', componentName: 'Employees', meta: { requiresAuth: true } },
  { path: '/employees/new', name: 'EmployeeNew', componentName: 'Employees/New', meta: { requiresAuth: true } },
  { path: '/employees/:employeeId', name: 'EmployeeDetail', componentName: 'Employees/Detail', props: true, meta: { requiresAuth: true } },

  { path: '/vehicles', name: 'Vehicles', componentName: 'Vehicles', meta: { requiresAuth: true } },
  { path: '/vehicles/new', name: 'VehicleNew', componentName: 'Vehicles/New', meta: { requiresAuth: true } },
  { path: '/vehicles/:vehicleId', name: 'VehicleDetail', componentName: 'Vehicles/Detail', props: true, meta: { requiresAuth: true } }
]

Vue.use(Router)

const routes = routerOptions.map(r => {
  return {
    ...r,
    component: () => import(`@/views/${r.componentName}/Index.vue`)
  }
})

const router = new Router({
  routes
})

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  const isAuthenticated = store.getters.isAuthenticated
  const alertIsVisible = store.getters.alertHasContent

  // If alert is visible, hide alert
  if (alertIsVisible) {
    store.dispatch('setAlertData', null)
  }

  if (requiresAuth && !isAuthenticated) {
    console.log('Necesitas estar logeado 👎')
    next({ name: 'LogIn' })
  } else {
    next()
  }
})

export default router
